module.exports = __webpack_public_path__ + "img/poulpe_rocket.9282d7da.png";